import OrderTransportingOrderForwardingSendRequest from "../../../../../api/raily/order/transporting-order/forwarding/send/order-transporting-order-forwarding-send.request";
import OrderTransportingOrderForwardingSendParams from "./order-transporting-order-forwarding-send-params";

const create = (
  params: OrderTransportingOrderForwardingSendParams,
): OrderTransportingOrderForwardingSendRequest => {
  return {
    contractId: params.contractId,
    orderId: params.orderId,
  };
};

const orderTransportingOrderForwardingSendParamsFactory = {
  create,
};

export default orderTransportingOrderForwardingSendParamsFactory;
